import publicApi from "../../publicApi";

export type Promotion = {
  id: number;
  image_url: string | null;
  description: string;
  starts_at: string | null;
  ends_at: string | null;
  sort_order: number;
};

export const promotionsService = {
  getActivePromotions: async (): Promise<Promotion[]> => {
    const response = await publicApi.get("/promotions");
    return response.data;
  },
};

